<script setup lang="ts">
import { LoaderCircle } from 'lucide-vue-next';
</script>

<template>
  <LoaderCircle class="w-24 h-24 animate-spin" />
</template>

<style scoped></style>
